import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import PT from 'prop-types';
import styled, { css } from 'styled-components';
import { isMobileStyleMixin, SurfaceDarkInfo, useTaktId, createStormTaktId, Icon, TextButton } from '@amzn/storm-ui';
import { t as times } from './LocalModules/storm-ui-icons/dist/esm/localIcons-EM4gOTGb-DpE3j47V.js';

const CloseButtonContainer = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30062554__sc-1r0r9by-0"
})(["margin:-8px 0;", ""], isMobileStyleMixin(css(["margin:0 -14px;display:flex;flex-direction:row-reverse;padding-bottom:", ";"], ({
  theme
}) => theme.mobile.spacing.mini)));
const PageBannerSurface = /*#__PURE__*/styled(SurfaceDarkInfo).withConfig({
  componentId: "sc-storm-ui-30062554__sc-1r0r9by-1"
})(["display:flex;flex-direction:row-reverse;flex-wrap:nowrap;justify-content:flex-start;align-content:stretch;align-items:stretch;border-radius:", ";box-shadow:", ";padding:", " 0;padding-inline-start:", ";padding-inline-end:", ";", ""], ({
  theme
}) => theme.card.radius, ({
  theme
}) => theme.card.boxShadow, ({
  theme
}) => theme.spacing.xlarge, ({
  theme
}) => theme.spacing.xxlarge, ({
  theme
}) => theme.spacing.xlarge, isMobileStyleMixin(css(["flex-direction:column;padding:", ";padding-top:", ";}"], ({
  theme
}) => theme.mobile.spacing.medium, ({
  theme
}) => theme.mobile.spacing.mini)));
const CloseButton = /*#__PURE__*/styled(TextButton).withConfig({
  componentId: "sc-storm-ui-30062554__sc-1r0r9by-2"
})(["width:", ";height:", ";"], ({
  theme
}) => theme.spacing.medium, ({
  theme
}) => theme.spacing.medium);
const CloseButtonWrapper = ({
  onClose,
  closeButtonAriaLabel,
  taktId,
  taktValue
}) => {
  const {
    getDataTaktAttributes
  } = useTaktId({
    taktId,
    fallbackId: createStormTaktId('page-banner-close-button')
  });
  return /*#__PURE__*/React.createElement(CloseButtonContainer, null, /*#__PURE__*/React.createElement(CloseButton, _extends({
    onClick: onClose,
    "aria-label": closeButtonAriaLabel
  }, getDataTaktAttributes({
    taktValue,
    taktIdSuffix: 'close-button'
  })), /*#__PURE__*/React.createElement(Icon, {
    type: times,
    size: "lg",
    blockSize: true
  })));
};
const PageBanner = ({
  children,
  onClose,
  closeButtonAriaLabel,
  taktId,
  taktValue,
  ...props
}) => {
  const {
    dataTaktId
  } = useTaktId({
    taktId,
    fallbackId: createStormTaktId('page-banner')
  });
  return /*#__PURE__*/React.createElement(PageBannerSurface, _extends({}, props, {
    taktId: dataTaktId
  }), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CloseButtonWrapper, {
    onClose: onClose,
    closeButtonAriaLabel: closeButtonAriaLabel,
    taktId: taktId,
    taktValue: taktValue
  }), children));
};
PageBanner.propTypes = {
  /**
   * Fired when a hitting close button.
   */
  onClose: PT.func.isRequired,
  /**
   * PageBanner must contain a `<MediaContainer/>` and `<TextContainer>`, in that order.
   */
  children: PT.node.isRequired
};
PageBanner.defaultProps = {};

export { PageBanner as P };
//# sourceMappingURL=PageBanner-DZrtyRiI.js.map
